<div class="alert {{classes}}" role="alert">
  <p *transloco="let t">
    <span *ngIf="titleText || titleTextTranslation" class="{{titleClass}}">{{ titleText || t(titleTextTranslation) }}</span>
    <span *ngIf="bodyText || bodyTextTranslation">{{ bodyText || t(bodyTextTranslation) }}</span>
    <a *ngIf="linkText || linkTextTranslation" class="text-link" (click)="doLinkEvent()">
      {{ linkText || t(linkTextTranslation) }}
    </a>
  </p>
</div>